import OrganizationNotesWrapper from "@/pages/organisaties/notities/OrganizationNotesWrapper"
import { checkPermissions } from "@/utils/checkPermissions"
import { createFileRoute, useParams } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/beheer/organisaties/$organizationId/notities/",
)({
  component: RouteComponent,
  beforeLoad: () => checkPermissions("read", "organizations"),
})

function RouteComponent() {
  const { organizationId } = useParams({
    from: "/beheer/organisaties/$organizationId/notities/",
  })

  return <OrganizationNotesWrapper organizationId={Number(organizationId)} />
}
